import { Row, Col, Tag, Checkbox } from 'antd';
import filter from "lodash/filter";
import uniqBy from "lodash/uniqBy";
import moment from 'moment';
import providerCodes from '../../../utils/providerCodes.json';
import evaluationTypes from "../../../utils/evaluationType.json";
import { useTranslation } from 'react-i18next';

const AdmissionSummary = ({
  patientToAdmission,
  providerCode,
  countryCode,
  laboratoryModule
}) => {
  const { t } = useTranslation();

  return (
    <Col className="admission-summary" lg={10} xs={22}>
      {
        patientToAdmission &&
        <Row justify="space-between">
          <Col className="box" lg={24} xs={24}>
            <Row>
              <Col lg={24} xs={24}>
                <h2 className='mb-20'>Resumen de admisión:</h2>
              </Col>
              <Col lg={24} xs={24}>
                <p className='mr-15'>
                  {t('admissionPage.admissionSummary.patient')}:
                  &nbsp;
                  <strong>
                    {`${patientToAdmission.userFirstName}  ${patientToAdmission.userLastName}`}
                  </strong>
                </p>
              </Col>
              <Col lg={24} xs={24}>
                <p className='mr-15'>{
                  patientToAdmission.documentType === 'passport'
                    ? 'Pasaporte'
                    : (patientToAdmission.documentType === 'ce'
                      ? 'Carnet de Extranjería'
                      : patientToAdmission.documentType && patientToAdmission.documentType.toUpperCase())
                }:&nbsp;
                  <strong>
                    {patientToAdmission.documentNumber}
                  </strong>
                </p>
              </Col>
              <Col lg={24} xs={24}>
                <p className='mr-15'>Fecha de nacimiento:
                  &nbsp;
                  <strong>
                    {moment(patientToAdmission.dateBirth).format('DD-MM-YYYY')}
                  </strong>
                </p>
              </Col>
              <Col lg={24} xs={24}>
                <p className='mr-15'>Teléfono:
                  &nbsp;
                  <strong>
                    {patientToAdmission.phone}
                  </strong>
                </p>
              </Col>
              <Col lg={24} xs={24}>
                <p className='mr-15'>Sexo:
                  &nbsp;
                  <strong>
                    {
                      patientToAdmission.genderId && patientToAdmission.genderId.toString() === '1' ? 'Femenino' : 'Masculino'
                    }
                  </strong>
                </p>
              </Col>
            </Row>
          </Col>

          <Col className="box" lg={24} xs={24}>
            <Row align="top">
              <Row className="title">
                <h2 className='mb-20'>
                  {t('admissionPage.admissionSummary.services')}:
                </h2>
              </Row>
            </Row>
            <Row className="content">
              <Col>
                <Row>
                  <p className='mr-15'>{t('admissionPage.admissionSummary.evaluationType')} :</p>
                  <strong>
                    {
                      (patientToAdmission.evaluation_type || patientToAdmission.evaluation_type === 0) &&
                      patientToAdmission && evaluationTypes[countryCode].find(type => type.value.toString() === patientToAdmission.evaluation_type.toString()).text
                    }
                  </strong>
                </Row>
              </Col>
              <Col>
                <Row>
                  <p className='mr-15'>{t('admissionPage.admissionSummary.patient')} diabético:</p>
                  <strong>
                    {patientToAdmission.diabetic === true ? 'Sí' : 'No'}
                  </strong>
                </Row>
              </Col>
            </Row>
            <Row className="prestations" lg={3}>
              <Col lg={{ order: 4, span: 24 }} xs={{ order: 3, span: 24 }}>
                {
                  patientToAdmission.prestations &&
                  filter(patientToAdmission.prestations, (item) => !Object.keys(item).includes('admission_patient_id')).map((service, index) => {
                    return (
                      <Tag
                        key={index}
                        visible
                        className='custom-tag mr-15 mb-15'
                      >
                        {service.name}
                      </Tag>
                    )
                  })
                }
              </Col>
            </Row>
          </Col>
          {
            laboratoryModule &&
            <Col className="box" lg={24} xs={24}>
              <Row className="title">
                <Row>
                  <h2 className='mb-20'>Exámenes de laboratorio en línea:</h2>
                </Row>
              </Row>
              <Row>
                <p className='mr-15'>Los siguientes exámenes de laboratorio se enviarán al laboratorio en linea <strong>{providerCodes[providerCode]}</strong>:</p>
              </Row>
              <Col className="laboratory-prestations-box">
                {
                  patientToAdmission.laboratoryPrestations &&
                  uniqBy(patientToAdmission.laboratoryPrestations, 'name').map((service, index) => {
                    return (
                      <Row className="laboratory-prestation">
                        <strong>
                          {service.name}
                        </strong>
                      </Row>
                    )
                  })
                }
              </Col>
            </Col>
          }
          {
            (laboratoryModule && providerCodes[providerCode] !== 'bupa') &&
            <Col className="box" lg={24} xs={24}>
              <Row className="title">
                <Row>
                  <h2 className='mb-20'>Exámenes de laboratorio envío manual:</h2>
                </Row>
              </Row>
              <Row>
                <p className='mr-15'>Los siguientes exámenes de laboratorio se deben enviar de forma <strong>manual</strong> al laboratorio deseado.</p>
              </Row>
              <Col className="laboratory-prestations-box">
                {
                  patientToAdmission.laboratoryPrestations &&
                  uniqBy(patientToAdmission.laboratoryPrestations.filter((p => !p.selected && !p.disabled)), 'name').map((service, index) => {
                    return (
                      <Row className="laboratory-prestation">
                        <strong>
                          {service.name}
                        </strong>
                      </Row>
                    )
                  })
                }
              </Col>
              <Row>
              </Row>
            </Col>
          }
          <Col className="box pb-30" lg={24} xs={24}>
            <Row className="title">
              <Row>
                <h2 className='mb-20'>Consentimientos</h2>
              </Row>
            </Row>
            {
              (patientToAdmission.consents && patientToAdmission.consents.length === 0) ?
                <Row lg={3}>
                  <p className='mr-15'>No hay consentimientos.</p>
                </Row> :
                <Row lg={3}>
                  <Col lg={{ order: 4, span: 24 }} xs={{ order: 3, span: 24 }}>
                    {
                      patientToAdmission.consents &&
                      patientToAdmission.consents.map((consent, index) => {
                        return (
                          <Row justify="space-between">
                            <Row>
                              <strong>{consent.title}</strong>
                            </Row>
                            <Row>
                              <p className='mr-15'>{(consent.signed) ? 'Completado' : 'Incompleto'}</p>
                              <Checkbox className='checkbox' disabled={!consent.signed} checked={consent.signed} />
                            </Row>
                          </Row>
                        )
                      })
                    }
                  </Col>
                </Row>
            }
          </Col>
        </Row>
      }
    </Col>
  );
};

export default AdmissionSummary;
